module.exports = __webpack_public_path__ + "static/img/default_program.15225de8.jpg";